<template>
  <div class="select">
    <select v-bind="{ ...$attrs, ...$props }" @input="onSelect($event.target.value)">
      <option disabled selected></option>
      <option v-for="(option, index) in options" :key="index" :value="option.code ? option.code : option">
        {{ option.description ? option.description : option }}
      </option>
    </select>

    <div class="select__icon">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 10L12 14L16 10" stroke="#373739" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <label
      :class="[
        'select__label',
        {
          'select__label--visible': value
        }
      ]"
    >
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'uiSelect',
  props: {
    value: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: () => [
        {
          value: 1,
          label: 'Selecione'
        }
      ],
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      valueBind: this.value
    }
  },
  methods: {
    onSelect (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  position: relative;
  width: 100%;

  select {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    border: 1px solid #6320e9;
    border-radius: 12px;
    color: #595959;
    cursor: pointer;
    font: bold 16px Oscine;
    height: 100%;
    min-height: 56px;
    padding: 17px 46px 0 16px;
    width: 100%;

    &:active,
    &:focus {
      border: 2px solid #6320e9 ;
      outline: none;
    }

    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 1000px #fff inset;
    }

    &:-ms-expand {
      display: none;
    }

    &:disabled {
      cursor: no-drop;
      color: #6320e9;
    }
  }

  &__icon {
    height: 24px;
    pointer-events: none;
    position: absolute;
    right: 16px;
    top: 17px;
    width: 24px;
  }

  &__label {
    color: #595959;
    cursor: pointer;
    font: normal 16px Rubik;
    left: 16px;
    pointer-events: none;
    position: absolute;
    top: 17px;
    transition-duration: 0.3s;
    transition-property: font-size, top, color;
    transition-timing-function: ease;

    &--visible {
      color: #595959;
      font: normal 16px Rubik;
      top: 6px;
    }
  }
}
</style>
